import FormContact from "@/vue/components/FormContact";

import Swiper from 'swiper';
import { Keyboard, Navigation, Pagination } from 'swiper/modules';

new Vue({
    el: '#similarProperties',
    name: 'SimilarProperties',
    data: {
        property: null,
        similarProperties: null,
    },

    mounted() {
        const content = document.querySelector('[name=data-property]')?.value;
        this.property = content ? JSON.parse(content) : null;
    },

    methods: {
        async loadSimilarProperties() {
            await axios.get(route('properties.similarProperties', this.property.ad.type, this.property.ad.id)).then((response) => {
                this.similarProperties = response.data.properties;

                this.updateBgSubsidiaryImage();
            }).catch(e => {
                console.log(e);
            });
        },

        updateBgSubsidiaryImage() {
            this.similarProperties.forEach((item) => {
                if (item.ad.type === 'improxy_property' || item.ad.type === 'external_property') {
                    if (item.subsidiary_logo) {
                        item.bgSubsidiaryImage = item.subsidiary_logo;
                    } else {
                        item.bgSubsidiaryImage = this.asset('/images/sem-foto.jpg');
                    }
                } else {
                    console.log(item.ad.account);
                    if (item.ad.account.company.logo && item.ad.account.company.logo !== '') {
                        item.bgSubsidiaryImage = item.ad.account.company.logo;
                    }
                }

                let query_string = "prop_id=" + item.id;

                if (item.ad.type === "improxy_property") {
                    query_string += "&src=ipxy";
                } else if (item.ad.type === "external_property") {
                    query_string += "&src=ext";
                }

                item.queryString = query_string;
            });
        },
    },
});

new Vue({
    el: '.withRecaptcha',
    name: 'FormRecaptcha',
    components: {
        FormContact
    },
    data() {
        return {
            endpoint: '',
        }
    },
    mounted() {
        const el = document.querySelector('#endpoint-vue');
        if (el) {
            this.endpoint = JSON.parse(el.value);
        }
    }
})
// core version + navigation, pagination modules:

// init Swiper:
const swipeShow = new Swiper('.swiper-prop-show', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    // Enable lazy loading
    lazy: {
        loadPrevNext: true, // pre-loads the next image to avoid showing a loading placeholder if possible
    },
    keyboard: {
        enabled: true,
    },
    // If we need pagination
    pagination: {
        el: '.swiper-pagination2',
        clickable: true,
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next2',
        prevEl: '.swiper-button-prev2',
    },

    // And if we need scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
    },
    modules: [Navigation, Pagination, Keyboard]
});

window.swipeShow = swipeShow;

const swiper = new Swiper('.swiper-fullscreen', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,

    lazy: true,
    // If we need pagination
    pagination: {
        el: '.swiper-pagination1',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next1',
        prevEl: '.swiper-button-prev1',
    },
    keyboard: {
        enabled: true,
        onlyInViewport: false,
    },
    // Navigation arrows
    // navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    // },
    //
    // // And if we need scrollbar
    // scrollbar: {
    //     el: '.swiper-scrollbar',
    // },
    modules: [Navigation, Pagination, Keyboard]
});

window.swiper = swiper;

// init Swiper:
new Swiper('.mySwiper', {

    // Optional parameters
    direction: 'horizontal',
    slidesPerView: 4,
    spaceBetween: 30,
    slidesPerGroup: 4,
    loop: false,
    loopFillGroupWithBlank: false,
    hashNavigation: true,
    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    keyboard: {
        enabled: true,
        onlyInViewport: false,
    },
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next3',
        prevEl: '.swiper-button-prev3',
    },
    autoplay: {
        delay: 5500,
        disableOnInteraction: false,
    },

    // And if we need scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
    },
    modules: [Navigation, Pagination, Keyboard]
});

setTimeout(() => {
    document.querySelector('[v-cloak]')?.removeAttribute('v-cloak')
}, 50)

$(document).ready(function () {
    $('.pop-fullscreen-images').click(function () {
        var active = document.querySelector('.normal.swiper-slide-active')
        if (!active) return;
        var dataIndex = active.getAttribute('data-index')
        var index = parseInt(dataIndex);
        swiper.slideToLoop(index, 0);
        getIndex()
        console.log('pop');
        $('body').addClass('body-stuck');
        $('.fullscreen-wrapper').addClass('fullscreen-pop');
        // $('.swiper .swiper-fullscreen .swiper-prop-fullscreen').removeClass('d-none');
        $('.swiper-fullscreen').addClass('d-block').removeClass('d-none');

        $('.fullscreen-wrapper .targetfotos').addClass('btn-effect');
        $('.change-container').removeClass('container');
        $('.change-container').addClass('container-fluid');

        $('.share').addClass('d-none');
        $('.fav').addClass('d-none');
        $('.share').addClass('d-md-block');
        $('.fav').addClass('d-md-block');

        $('.wraper-fullscreen').addClass('d-flow-root');

        // setTimeout(() => {
        //     if(initialize === false){
        //         console.log(window.swiper.slides)
        //         // Array.from(swiper.slides).forEach(function(slide) {
        //         //     openFullscreenSliderHandler(slide);
        //         //     closeFullscreenSliderHandler(slide);
        //         // });
        //         initialize = true;
        //         document.querySelector('.swiper-button-next1').addEventListener('click', () => console.log);
        //     }
        // }, 500)
    });
    $(document).on('click', '.popoff-fullscreen', function () {
        closeFullscreenSlider();
    });
});

// Função global para fechar o slider fullscreen
function closeFullscreenSlider() {
    console.log('closeFullscreenSlider called');
    $('body').removeClass('body-stuck');
    $('.fullscreen-wrapper').removeClass('fullscreen-pop');
    $('.fullscreen-wrapper  .targetfotos').removeClass('btn-effect');
    $('.fullscreen-wrapper .targetvideos').removeClass('btn-effect');

    $('.change-container').removeClass('container-fluid');
    $('.change-container').addClass('container');
    $('.video').addClass('d-none').removeClass('d-block');
    $('.swiper-fullscreen').addClass('d-none').removeClass('d-block');

    $('.share').removeClass('d-none');
    $('.fav').removeClass('d-none');
    $('.wraper-fullscreen').removeClass('d-flow-root');
}

window.closeFullscreenSlider = closeFullscreenSlider;

// Dummy block to maintain structure
$(function() {
    $('.pop-fullscreen-video').click(function () {
        console.log('video');
        $('.fullscreen-wrapper').addClass('fullscreen-pop');
        $('.fullscreen-wrapper .targetvideos').addClass('btn-effect');
        $('.video').addClass('d-block').removeClass('d-none');
    });
    $('.pop-fullscreen-video-3d').click(function () {
        console.log('video-3d');
        $('.fullscreen-wrapper').addClass('fullscreen-pop');
        $('.fullscreen-wrapper .targetvideos-3d').addClass('btn-effect');
        $('.video-3d').addClass('d-block').removeClass('d-none');
    });
    $('.targetfotos').click(function () {
        $('.change-on-fullscreen-videos').removeClass('btn-effect');
        $('.targetfotos').addClass('btn-effect');
        $('.video').addClass('d-none').removeClass('d-block');
        $('.swiper-fullscreen').addClass('d-block').removeClass('d-none');

        $('.share').addClass('d-none');
        $('.fav').addClass('d-none');
    });
    $('.change-on-fullscreen-videos').click(function () {
        $('.change-on-fullscreen-videos').addClass('btn-effect');
        $('.targetfotos').removeClass('btn-effect');
        $('.swiper-fullscreen').addClass('d-none').removeClass('d-block');
        $('.video').addClass('d-block').removeClass('d-none');
    });

    //Set videoAnchor
    // let url = window.location.href.split("#")[0];
    //
    // const queryString = window.location.search;
    //
    // const urlParams = new URLSearchParams(queryString);
    //
    // let video = urlParams.get('video');
    //
    // if(!video){
    //     document.getElementById("videoAnchor").href = url + '&video=true#video';
    // }

    //Check if url has video hash
    var hash = window.location?.hash;

    //Open video if hash is set
    if (hash === '#video') {
        //Open video
        console.debug('Video hash found');
        $('.pop-fullscreen-video').click();
    }
});

function videoUrl() {
    //Set videoAnchor
    let url = window.location.href.split("#")[0];

    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);

    let video = urlParams.get('video');

    if (!video) {
        var separator = url.includes('?') ? '&' : '?';
        window.history.pushState("", "", url + separator + 'video=true#video');
    }
}

window.videoUrl = videoUrl;

function toggleExcluded(adId) {
    const userEl = document.querySelector('[name="data-user"]');
    if (!userEl) return;
    const user = JSON.parse(userEl.value);
    if (!user) {
        const myModal = new window.bootstrap.Modal(document.getElementById('model-exclude'), {})
        myModal.toggle();
        return
    }

    axios.post(route('api.marked-ads.toggle-property-excluded-by-auth', adId)).then(({data: {message}}) => {
        // const elSwal = document.querySelector('.swal2-icon.swal2-icon-show')
        Swal.fire({
            title: "Imóvel excluído",
            html: message,
            iconHtml: '<img class="" style="width: 30px" src="/images/trash_new.svg" alt="">',
            confirmButtonText: "Fechar",
            customClass: {
                icon: 'border-blue'
            }
        }).then(() => {
            document.querySelector(`[data-property-ad-id="${adId}"]`)?.remove()
        });
    })
}

window.toggleExcluded = toggleExcluded

function getIndex() {
    setTimeout(() => {
        var active = document.querySelector('.swiper-fullscreen .swiper-slide-active')
        var dataIndex = active?.getAttribute('data-index')
        var index = parseInt(dataIndex || 0);
        index += 1;
        const indexFoto = document.getElementById('index-foto');
        if (indexFoto) indexFoto.innerText = index;
        console.debug('index', index)
        console.debug('dataIndex', dataIndex)
        console.debug('div active', active);
        swipeShow.slideToLoop(parseInt(dataIndex), 0);
    }, 200)
}

window.getIndex = getIndex;

document.addEventListener("DOMContentLoaded", function () {
    // loadYT();
    console.debug('DOM loaded');
    document.querySelector('#video-url')?.addEventListener('click', videoUrl);

    document.addEventListener('keyup', (e) => {
        e.preventDefault();
        if (e.key === "Escape") {
            console.debug('Escape pressed');
            $('.popoff-fullscreen').click();
        }
    })

    document.querySelectorAll('[data-get-index]').forEach(el => {
        el.addEventListener('click', getIndex)
    })

    window.addEventListener('scroll', () => listeningScroll())

    document.querySelectorAll('[data-trigger="copy"]').forEach(el => {
        console.debug('el', el)
        el.addEventListener('click', function () {
            let copyText = document.querySelector(el.getAttribute('data-target'))?.innerText;
            console.debug('copyText', copyText);
            let textArea = document.createElement("textarea");
            textArea.value = copyText;

            // Avoid scrolling to bottom
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                let successful = document.execCommand('copy');
                let msg = successful ? 'successful' : 'unsuccessful';
                console.debug('Copying text command was ' + msg);
            } catch (err) {
                //
            }

            document.body.removeChild(textArea);
        });
    })

    setTimeout(() => {
        onErrorImage();
    }, 200);
});

function listeningScroll() {
    const navbarTop = document.getElementById('navbar_top');
    if (!navbarTop) return;

    if (window.scrollY > 150) {
        navbarTop.classList.add('fixed-top');
        navbarTop.classList.add('d-block');
        navbarTop.classList.remove('d-none');

        // add padding top to show content behind navbar
        let navbarEl = document.querySelector('.navbar');
        if (!navbarEl) return;
        let navbar_height = navbarEl.offsetHeight;
        document.body.style.paddingTop = navbar_height + 'px';
    } else {
        navbarTop.classList.remove('fixed-top');
        navbarTop.classList.remove('d-block');
        navbarTop.classList.add('d-none');
        // remove padding top from body
        document.body.style.paddingTop = '0';
    }
}

function loadYT() {
    const hasVideoEl = document.querySelector('[name=data-has-video]');
    if (!hasVideoEl) return;
    const hasVideo = JSON.parse(hasVideoEl.value);
    console.debug('hasVideo', hasVideo);

    if (!hasVideo) {
        return;
    }

    if (window.hideYTActivated) {
        return
    }

    let onYouTubeIframeAPIReadyCallbacks = [];
    for (let playerWrap of document.querySelectorAll(".video-container")) {
        let playerFrame = playerWrap.querySelector("iframe");
        let tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        let onPlayerStateChange = function (event) {
            if (event.data == YT.PlayerState.ENDED) {
                playerWrap.classList.add("ended");
            } else if (event.data == YT.PlayerState.PAUSED) {
                playerWrap.classList.add("paused");
            } else if (event.data == YT.PlayerState.PLAYING) {
                playerWrap.classList.remove("ended");
                playerWrap.classList.remove("paused");
            }
        };
        let player;
        onYouTubeIframeAPIReadyCallbacks.push(function () {
            player = new YT.Player(playerFrame, {events: {'onStateChange': onPlayerStateChange}});
        });
        playerWrap.addEventListener("click", function () {
            let playerState = player.getPlayerState();
            if (playerState == YT.PlayerState.ENDED) {
                player.seekTo(0);
            } else if (playerState == YT.PlayerState.PAUSED) {
                player.playVideo();
            }
        });
    }
    window.onYouTubeIframeAPIReady = function () {
        for (let callback of onYouTubeIframeAPIReadyCallbacks) {
            callback();
        }
    };
    window.hideYTActivated = true;
}

function onErrorImage() {
    document.querySelectorAll('.swiper-lazy').forEach(el => {
        el.onerror = function () {
            console.debug('error image')
            this.src = '/images/noLogo.svg';
            this.style.width = '400px';
            this.style.height = '400px';
        }
    })
}
